import { useState } from "react";
import { toast } from "react-toastify";

// Calls
import { setDefaultPaymentMethodRequest } from "../../../../api/calls/subscription.call";

// Billing UI
import { AddCardModal, RemoveCardModal } from "./CardModals";
import { I, CardBrand, brandName } from "./icons";

const PaymentRow = ({ card, onMakeDefault, onRemove }) => (
  <div className="pm-row">
    <span className="card-brand">
      <CardBrand brand={card.brand} />
    </span>
    <div className="pm-mid">
      <div className="pm-name">
        {brandName(card.brand)} •••• {card.last4}
        {card.isDefault && (
          <span className="badge badge-accent" style={{ fontSize: 10 }}>
            Default
          </span>
        )}
        {card.isExpired && (
          <span className="badge badge-error" style={{ fontSize: 10 }}>
            Expired
          </span>
        )}
      </div>
      <div className="pm-exp">Expires {card.expLabel}</div>
    </div>
    <div className="pm-actions">
      {!card.isDefault && (
        <button className="link" onClick={onMakeDefault}>
          Make default
        </button>
      )}
      <button className="link danger" onClick={onRemove}>
        Remove
      </button>
    </div>
  </div>
);

const PaymentMethodsPanel = ({ cards, onRefresh }) => {
  const [modal, setModal] = useState(null); // {type:'add'} | {type:'remove', card}

  const makeDefault = async card => {
    const response = await setDefaultPaymentMethodRequest(card.id);
    if (response.hasError) {
      toast.error(response.error.message);
      return;
    }
    toast.success("Default payment method updated.");
    onRefresh();
  };

  return (
    <div className="panel">
      <div className="panel-head">
        <div className="panel-eyebrow">Payment methods</div>
        <button
          className="btn btn-ghost btn-sm"
          onClick={() => setModal({ type: "add" })}
        >
          <I.Plus width="13" height="13" /> Add payment method
        </button>
      </div>
      <div className="panel-body">
        {cards.length === 0 ? (
          <div className="bp-empty">
            <div className="bp-empty-ico">
              <I.Card width="22" height="22" />
            </div>
            <div className="bp-empty-title">No payment methods yet</div>
            <div className="bp-empty-text">
              Add a card to pay for your subscription.
            </div>
            <button
              className="btn btn-primary"
              onClick={() => setModal({ type: "add" })}
            >
              <I.Plus width="13" height="13" /> Add payment method
            </button>
          </div>
        ) : (
          <div className="pm-list">
            {cards.map(card => (
              <PaymentRow
                key={card.id}
                card={card}
                onMakeDefault={() => makeDefault(card)}
                onRemove={() => setModal({ type: "remove", card })}
              />
            ))}
          </div>
        )}
      </div>

      {modal?.type === "add" && (
        <AddCardModal onClose={() => setModal(null)} onSaved={onRefresh} />
      )}
      {modal?.type === "remove" && (
        <RemoveCardModal
          card={modal.card}
          onClose={() => setModal(null)}
          onRemoved={onRefresh}
        />
      )}
    </div>
  );
};

export default PaymentMethodsPanel;
